import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { SearchIcon } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { VendorCard } from "@/components/common/VendorCard";
import { CardSkeletons, EmptyState } from "@/components/common/States";

export default function Search() {
  const [q, setQ] = useState("");
  const vendors = useQuery({
    queryKey: ["vendor-search", q],
    queryFn: () => api(`/vendors${q ? `?q=${encodeURIComponent(q)}` : ""}`),
  });

  return (
    <div className="space-y-6">
      <div className="relative">
        <SearchIcon className="pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-muted-foreground" />
        <Input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search stores by name…"
          className="h-12 rounded-full pl-12 text-base"
          data-testid="search-input"
        />
      </div>

      {vendors.isLoading ? (
        <CardSkeletons />
      ) : vendors.data?.length === 0 ? (
        <EmptyState icon={SearchIcon} title="No stores found" description="Try a different search term." />
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {vendors.data.map((v) => (
            <VendorCard key={v.vendor_id} vendor={v} />
          ))}
        </div>
      )}
    </div>
  );
}
